import { axiosAuth } from './axiosInstances'

// KHAN-238: apps.BooksDilemma -> apps.books_dilemma, api/bookdilemma/{...}
// con verbos en el path -> 4 recursos REST kebab-case + 1 sub-recurso, cada
// uno con barra final por convencion codebase-wide (ver apps.translate/
// KHAN-261, apps.books_per_classes/KHAN-236). Los nombres de funcion
// exportados no cambian (siguen siendo el contrato que consumen
// MyBookClasses, BookBuilder, BookBuilderStepper, BookCard, TapLibrary),
// solo las URLs/metodos HTTP internos.

export async function listCategories() {
  return axiosAuth().get('book-categories/')
}

export async function listDimensions() {
  return axiosAuth().get('book-dimensions/')
}

export async function searchCategory(categoryId) {
  return axiosAuth().get('book-categories/' + categoryId + '/')
}

// Audit fix: an undefined/null id used to be concatenated into
// "?category=undefined", which the backend rejects with a 400 (a request-error
// toast in BookBuilder). Answer with an empty list instead, like a category
// that has no dimensions.
export async function searchDimensionByCategory(categoryId) {
  if (categoryId === undefined || categoryId === null || categoryId === '') {
    return { data: [] }
  }
  return axiosAuth().get('book-dimensions/', { params: { category: categoryId } })
}

export async function searchDilemmaByDimension(dimensionId) {
  if (dimensionId === undefined || dimensionId === null || dimensionId === '') {
    return { data: [] }
  }
  return axiosAuth().get('book-dilemmas/', { params: { dimension: dimensionId } })
}

export async function newDilemaPerBook(bookdilemmaid, bookid) {
  return axiosAuth().post('dilemmas-per-book/', {
    bookdilemmaid: bookdilemmaid,
    bookid: bookid,
  })
}

// Obtener categoría, dimensiones y dilemas de un libro
export async function getBookCategoryDimensionDilemmas(bookid) {
  return axiosAuth().get(`books/${bookid}/categories/`)
}
